<div>
  <div class="address-select-row">
    @if (addresses.length > 0) {
      <ion-list class="address-select-list">
        <ion-item>
          <ion-select aria-label="address" interface="popover" [interfaceOptions]="{ cssClass: 'address-select-popover' }" label="Select address" labelPlacement="floating" [(ngModel)]="selectedAddress" [compareWith]="compareAddress" (ionChange)="onAddressSelect($event.detail.value)">
            @for (address of addresses; track $index) {
              <ion-select-option [value]="address">{{toUpperCase(address?.unit_number)}} {{toUpperCase(address?.estate)}} {{toUpperCase(address?.sectional_title)}} {{toUpperCase(address?.street_number)}} {{toUpperCase(address?.street_name)}}</ion-select-option>
            }
          </ion-select>
        </ion-item>
      </ion-list>
    } @else {
      <ion-item class="address-select-list">
        <label>No addresses found</label>
      </ion-item>
    }
    <ion-button mode="ios" class="primary-button" style="width: auto !important;" (click)="addNewAddress()">
      <ion-icon name="add-sharp"></ion-icon>
    </ion-button>
  </div>
  @if (selectedAddress) {
    <div class="address-seleced-body">
      <ion-item mode="ios" class="field-item">
        <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.address_type)">
          <div slot="label">
            <ion-text class="standard-input-label">Address type</ion-text>
          </div>
        </ion-input>
      </ion-item>

      <ion-item mode="ios" class="field-item">
        <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.province)">
          <div slot="label">
            <ion-text class="standard-input-label">Province</ion-text>
          </div>
        </ion-input>
      </ion-item>

      <ion-item mode="ios" class="field-item">
        <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.suburb)">
          <div slot="label">
            <ion-text class="standard-input-label">Suburb</ion-text>
          </div>
        </ion-input>
      </ion-item>

      <ion-item mode="ios" class="field-item">
        <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.postal_code)">
          <div slot="label">
            <ion-text class="standard-input-label">Postal code</ion-text>
          </div>
        </ion-input>
      </ion-item>

      @if (selectedAddress.address_type === 'street') {
        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.street_name)">
            <div slot="label">
              <ion-text class="standard-input-label">Street name</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.street_number)">
            <div slot="label">
              <ion-text class="standard-input-label">Street number</ion-text>
            </div>
          </ion-input>
        </ion-item>
      }

      @if (selectedAddress.address_type === 'estate') {
        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.street_name)">
            <div slot="label">
              <ion-text class="standard-input-label">Street name</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.street_number)">
            <div slot="label">
              <ion-text class="standard-input-label">Street number</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.estate)">
            <div slot="label">
              <ion-text class="standard-input-label">Estate</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.unit_number)">
            <div slot="label">
              <ion-text class="standard-input-label">Unit number</ion-text>
            </div>
          </ion-input>
        </ion-item>
      }

      @if (selectedAddress.address_type === 'sectional') {
        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.street_name)">
            <div slot="label">
              <ion-text class="standard-input-label">Street name</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.street_number)">
            <div slot="label">
              <ion-text class="standard-input-label">Street number</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.sectional_title)">
            <div slot="label">
              <ion-text class="standard-input-label">Sectional title</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(selectedAddress.unit_number)">
            <div slot="label">
              <ion-text class="standard-input-label">Unit number</ion-text>
            </div>
          </ion-input>
        </ion-item>
      }
    </div>
  }
</div>

@if (newAddressPopup) {
  <div class="address-popup">
    <div class="limit-width-on-desktop-float">
      <div class="heading">
        <h2 class="h2-bold text-center">Add Address</h2>
      </div>
      <div class="body">
        <ion-item mode="ios" class="field-item" (click)="showSelect('address_type')">
          <ion-input labelPlacement="floating" readonly="true" [ngModel]="toUpperCase(newAddressPayload.address_type)" (ngModelChange)="newAddressPayload.address_type = $event">
            <div slot="label">
              <ion-text class="standard-input-label">Address type</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.address_type" (click)="showSelect('province')">
          <ion-input labelPlacement="floating" readonly="true" [disabled]="!newAddressPayload.address_type" [ngModel]="toUpperCase(newAddressPayload.province)" (ngModelChange)="newAddressPayload.province = $event">
            <div slot="label">
              <ion-text class="standard-input-label">Province</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.province" (click)="showSelect('suburb')">
          <ion-input labelPlacement="floating" readonly="true" [disabled]="!newAddressPayload.province" [ngModel]="toUpperCase(newAddressPayload.suburb)" (ngModelChange)="newAddressPayload.suburb = $event">
            <div slot="label">
              <ion-text class="standard-input-label">Suburb</ion-text>
            </div>
          </ion-input>
        </ion-item>

        <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.suburb">
          <ion-input labelPlacement="floating" inputmode="numeric" maxlength="4" [disabled]="!newAddressPayload.suburb" [ngModel]="toUpperCase(newAddressPayload.postal_code)" (ngModelChange)="onPostalCodeChange($event)">
            <div slot="label">
              <ion-text class="standard-input-label">Postal code</ion-text>
            </div>
          </ion-input>
        </ion-item>

        @if (newAddressPayload.address_type === 'street') {
          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code" (click)="showSelect('street_name')">
            <ion-input labelPlacement="floating" readonly="true" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.street_name)" (ngModelChange)="newAddressPayload.street_name = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Street name</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code">
            <ion-input labelPlacement="floating" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.street_number)" (ngModelChange)="newAddressPayload.street_number = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Street number</ion-text>
              </div>
            </ion-input>
          </ion-item>
        }

        @if (newAddressPayload.address_type === 'estate') {
          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code" (click)="showSelect('street_name')">
            <ion-input labelPlacement="floating" readonly="true" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.street_name)" (ngModelChange)="newAddressPayload.street_name = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Street name</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code">
            <ion-input labelPlacement="floating" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.street_number)" (ngModelChange)="newAddressPayload.street_number = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Street number</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code" (click)="showSelect('estate')">
            <ion-input labelPlacement="floating" readonly="true" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.estate)" (ngModelChange)="newAddressPayload.estate = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Estate</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code">
            <ion-input labelPlacement="floating" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.unit_number)" (ngModelChange)="newAddressPayload.unit_number = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Unit number</ion-text>
              </div>
            </ion-input>
          </ion-item>
        }

        @if (newAddressPayload.address_type === 'sectional') {
          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code" (click)="showSelect('street_name')">
            <ion-input labelPlacement="floating" readonly="true" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.street_name)" (ngModelChange)="newAddressPayload.street_name = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Street name</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code">
            <ion-input labelPlacement="floating" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.street_number)" (ngModelChange)="newAddressPayload.street_number = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Street number</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code" (click)="showSelect('sectional_title')">
            <ion-input labelPlacement="floating" readonly="true" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.sectional_title)" (ngModelChange)="newAddressPayload.sectional_title = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Sectional title</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <ion-item mode="ios" class="field-item" [class.item-disabled]="!newAddressPayload.postal_code">
            <ion-input labelPlacement="floating" [disabled]="!newAddressPayload.postal_code" [ngModel]="toUpperCase(newAddressPayload.unit_number)" (ngModelChange)="newAddressPayload.unit_number = $event">
              <div slot="label">
                <ion-text class="standard-input-label">Unit number</ion-text>
              </div>
            </ion-input>
          </ion-item>
        }
      </div>
    </div>
    <div class="button-rows" style="margin: 30px 0;">
      <ion-button mode="ios" class="primary-button" [disabled]="isSaveDisabled()" (click)="save()">
        <span class="button-inner"> Save </span>
      </ion-button>
      <ion-button mode="ios" class="secondary-button" (click)="cancelAddress()"> Cancel </ion-button>
    </div>
  </div>
}

@if (selectPopup) {
  <div class="backdrop">
    <div class="popup-native-select limit-width-on-desktop-float">
      <div class="heading" style="display: inline-flex; width: 100%;">
        <h2 class="h2-bold" style="width: 50%;">{{selectPopHeading}}</h2>
        <div style="width: 50%; text-align: right;" >
          <ion-icon name="close" slot="end" style="width: 24px; height: 24px;" (click)="closePopupAndClear()"></ion-icon>
        </div>
      </div>
      <div class="body">
        <div class="wrapper-select-data">
          @if (is_searchable) {
            <input #searchInput type="text" class="input-search" placeholder="Search" (keyup)="searchData($event)"/>
          }
          @if (searchFound && searchFound.length > 0) {
            @for (data of searchFound; track $index) {
              <div (click)="populateAddressPayload(data.code, data.description)" class="inner-wrapper">
                  {{data.description}}
              </div>
            }
          } @else if (!hideDefualtResults) {
            @for (data of selectData; track $index) {
              <div (click)="populateAddressPayload(data.code, data.description)" class="inner-wrapper">
                  {{data.description}}
              </div>
            }
          } @else {
            @if (free_text_message) {
              <div (click)="saveManuallyEnteredText()" class="inner-wrapper">
                Use <b>{{manual_text}}</b>
              </div>
            } @else {
              <small>No results found!</small>
            }
          }
        </div>
      </div>
    </div>
  </div>
}